function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { useMemo } from 'react';
import { Label } from '../../components/ui/label';
import { Separator } from '../../components/ui/separator';
import { cn } from '../../lib/utils';
function FieldSet(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("fieldset", _object_spread({
        "data-slot": "field-set",
        className: cn('flex flex-col gap-6', 'has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3', className)
    }, props));
}
function FieldLegend(_0) {
    let { className, variant = 'legend' } = _0, props = _object_without_properties(_0, [
        "className",
        "variant"
    ]);
    return /*#__PURE__*/ _jsx("legend", _object_spread({
        "data-slot": "field-legend",
        "data-variant": variant,
        className: cn('mb-3 font-medium', 'data-[variant=legend]:text-base', 'data-[variant=label]:text-sm', className)
    }, props));
}
function FieldGroup(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread({
        "data-slot": "field-group",
        className: cn('group/field-group @container/field-group flex w-full flex-col gap-7 data-[slot=checkbox-group]:gap-3 [&>[data-slot=field-group]]:gap-4', className)
    }, props));
}
const fieldVariants = cva('group/field flex w-full gap-3 data-[invalid=true]:text-destructive', {
    variants: {
        orientation: {
            vertical: [
                'flex-col [&>*]:w-full [&>.sr-only]:w-auto'
            ],
            horizontal: [
                'flex-row items-center',
                '[&>[data-slot=field-label]]:flex-auto',
                'has-[>[data-slot=field-content]]:items-start has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px'
            ],
            responsive: [
                'flex-col [&>*]:w-full [&>.sr-only]:w-auto @md/field-group:flex-row @md/field-group:items-center @md/field-group:[&>*]:w-auto',
                '@md/field-group:[&>[data-slot=field-label]]:flex-auto',
                '@md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px'
            ]
        }
    },
    defaultVariants: {
        orientation: 'vertical'
    }
});
function Field(_0) {
    let { className, orientation = 'vertical' } = _0, props = _object_without_properties(_0, [
        "className",
        "orientation"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread({
        role: "group",
        "data-slot": "field",
        "data-orientation": orientation,
        className: cn(fieldVariants({
            orientation
        }), className)
    }, props));
}
function FieldContent(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread({
        "data-slot": "field-content",
        className: cn('group/field-content flex flex-1 flex-col gap-1.5 leading-snug', className)
    }, props));
}
function FieldLabel(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(Label, _object_spread({
        "data-slot": "field-label",
        className: cn('group/field-label peer/field-label flex w-fit gap-2 leading-snug group-data-[disabled=true]/field:opacity-50', 'has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col has-[>[data-slot=field]]:rounded-md has-[>[data-slot=field]]:border [&>*]:data-[slot=field]:p-4', 'has-data-[state=checked]:bg-primary/5 has-data-[state=checked]:border-primary dark:has-data-[state=checked]:bg-primary/10', className)
    }, props));
}
function FieldTitle(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread({
        "data-slot": "field-label",
        className: cn('flex w-fit items-center gap-2 text-sm leading-snug font-medium group-data-[disabled=true]/field:opacity-50', className)
    }, props));
}
function FieldDescription(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("p", _object_spread({
        "data-slot": "field-description",
        className: cn('text-muted-foreground text-sm leading-normal font-normal group-has-[[data-orientation=horizontal]]/field:text-balance', 'last:mt-0 nth-last-2:-mt-1 [[data-variant=legend]+&]:-mt-1.5', '[&>a:hover]:text-primary [&>a]:underline [&>a]:underline-offset-4', className)
    }, props));
}
function FieldSeparator(_0) {
    let { children, className } = _0, props = _object_without_properties(_0, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        "data-slot": "field-separator",
        "data-content": !!children,
        className: cn('relative -my-2 h-5 text-sm group-data-[variant=outline]/field-group:-mb-2', className)
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Separator, {
                className: "absolute inset-0 top-1/2"
            }),
            children && /*#__PURE__*/ _jsx("span", {
                className: "bg-background text-muted-foreground relative mx-auto block w-fit px-2",
                "data-slot": "field-separator-content",
                children: children
            })
        ]
    }));
}
function FieldError(_0) {
    let { className, children, errors } = _0, props = _object_without_properties(_0, [
        "className",
        "children",
        "errors"
    ]);
    const content = useMemo(()=>{
        if (children) {
            return children;
        }
        if (!(errors === null || errors === void 0 ? void 0 : errors.length)) {
            return null;
        }
        const uniqueErrors = [
            ...new Map(errors.map((error)=>[
                    error === null || error === void 0 ? void 0 : error.message,
                    error
                ])).values()
        ];
        if ((uniqueErrors === null || uniqueErrors === void 0 ? void 0 : uniqueErrors.length) == 1) {
            var _uniqueErrors_;
            return (_uniqueErrors_ = uniqueErrors[0]) === null || _uniqueErrors_ === void 0 ? void 0 : _uniqueErrors_.message;
        }
        return /*#__PURE__*/ _jsx("ul", {
            className: "ml-4 flex list-disc flex-col gap-1",
            children: uniqueErrors.map((error, index)=>(error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/ _jsx("li", {
                    children: error.message
                }, index))
        });
    }, [
        children,
        errors
    ]);
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        role: "alert",
        "data-slot": "field-error",
        className: cn('text-destructive text-sm font-normal', className)
    }, props), {
        children: content
    }));
}
export { Field, FieldContent, FieldDescription, FieldError, FieldGroup, FieldLabel, FieldLegend, FieldSeparator, FieldSet, FieldTitle };
